export { default } from './Dialog';
export type { DialogProps } from './Dialog';
